// extracted by mini-css-extract-plugin
export default {"titleCell":"columns_titleCell__Xod21","titleText":"columns_titleText__Itwn-"};